import { createElement, useMemo } from 'react'

import { createStyles } from 'antd-style'

import { getIconByMimeType } from '@eastcoal/common/utils/mimeType'
import { pick } from '@eastcoal/common/utils/object'

import { AttachmentItem } from '../Item'
import { useAttachmentCardStore } from '../Store/hooks/useStore'
import { AttachmentToolbar } from '../Toolbar'

const useStyles = createStyles(({ prefixCls, token }) => ({
  item: {
    color: token.colorPrimaryText,
    cursor: 'pointer',
    [`&:hover,&:focus`]: {
      backgroundColor: token.colorPrimaryBgHover
    }
  }
}))

export const AttachmentInfo = () => {
  const { filename, mimeType } = useAttachmentCardStore(state =>
    pick(state, ['filename', 'mimeType'])
  )

  const { styles } = useStyles()

  const icon = useMemo(() => {
    const IconComponent = getIconByMimeType(mimeType)
    return createElement(IconComponent)
  }, [mimeType])

  return (
    <AttachmentToolbar>
      <AttachmentItem className={styles.item} filename={filename} icon={icon} />
    </AttachmentToolbar>
  )
}
